(function () {
  'use strict';

  var SHOW_DELAY = 500;
  var VISIBLE_DURATION = 8000;

  function seededRand(n) {
    return Math.abs(Math.sin(n * 9301 + 49297)) % 1;
  }

  function seededInt(n, min, max) {
    return min + Math.floor(seededRand(n) * (max - min + 1));
  }

  function showCard(card) {
    card.classList.add('product-sp-card--visible');
  }

  function dismissCard(card) {
    card.classList.remove('product-sp-card--visible');
    card.addEventListener('transitionend', function handler() {
      card.style.display = 'none';
      card.removeEventListener('transitionend', handler);
    });
  }

  function initSocialProof(overlay) {
    var productId = parseInt(overlay.dataset.productId, 10);
    if (!productId) return;

    var viewersCard = overlay.querySelector('[data-sp-card="viewers"]');
    var basketsCard = overlay.querySelector('[data-sp-card="baskets"]');
    var viewersEl = overlay.querySelector('[data-role="viewers"]');
    var basketsEl = overlay.querySelector('[data-role="baskets"]');

    if (!viewersEl || !basketsEl) return;

    viewersEl.textContent = seededInt(productId, 3, 9);
    basketsEl.textContent = seededInt(productId + 1, 1, 4);

    overlay.querySelectorAll('.product-sp-card__close').forEach(function (btn) {
      btn.addEventListener('click', function () {
        dismissCard(btn.closest('.product-sp-card'));
      });
    });

    var hideTimer;
    var showTimer = setTimeout(function () {
      showCard(viewersCard);
      showCard(basketsCard);

      hideTimer = setTimeout(function () {
        dismissCard(viewersCard);
        dismissCard(basketsCard);
      }, VISIBLE_DURATION);
    }, SHOW_DELAY);

    var observer = new MutationObserver(function () {
      if (!document.contains(overlay)) {
        clearTimeout(showTimer);
        clearTimeout(hideTimer);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function setup() {
    document.querySelectorAll('.product-sp-overlay').forEach(initSocialProof);
  }

  document.addEventListener('product-info:loaded', setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
